export const PACE_OPTIONS = [
  { value: "2_lessons_per_week", label: "2 lessons per week" },
  { value: "3_lessons_per_week", label: "3 lessons per week" },
  { value: "5_lessons_per_week", label: "5 lessons per week" },
  { value: "custom", label: "Custom pace" },
] as const;

export type PaceValue = (typeof PACE_OPTIONS)[number]["value"];

export const VALID_PACE_VALUES: readonly PaceValue[] = PACE_OPTIONS.map(
  (option) => option.value,
) as PaceValue[];

export const REVIEWABLE_TYPES = ["lesson", "placement_quiz", "course_placement"] as const; // 'quiz' removed - handlers not implemented

export type ReviewType = (typeof REVIEWABLE_TYPES)[number];

// Named constants for better readability and type safety
export const REVIEW_TYPE_LESSON = REVIEWABLE_TYPES[0];
export const REVIEW_TYPE_PLACEMENT_QUIZ = REVIEWABLE_TYPES[1];

// Fallback title for placement quizzes (should not be needed if schema is correct)
// Note: PlacementQuiz.title is non-nullable in schema, but this provides a safe fallback
export const UNTITLED_PLACEMENT_QUIZ = "Untitled Placement Quiz";

// Status constants for content review workflow
export const STATUS_APPROVED = "APPROVED";
export const STATUS_PENDING_REVIEW = "PENDING_REVIEW";
export const STATUS_REJECTED = "REJECTED";
export const STATUS_GENERATING = "GENERATING";

export const COURSE_DEFAULTS = {
  DESCRIPTION_PREFIX: "Comprehensive guide to",
  TRACK: "General Track",
  DEFAULT_IMAGE: "/images/courses/python-ai-no-text.png",
  LESSON_DURATION_MINUTES: 30,
  LESSON_TYPE: "video",
} as const;
